var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUjLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1024.000000pt",
    height: "1024.000000pt",
    viewBox: "0 0 1024.000000 1024.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1024.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6580 8374 c-82 -22 -171 -77 -231 -142 -321 -346 -86 -902 380 -902 148 0 267 49 369 152 103 102 152 221 152 368 0 254 -147 452 -389 524 -68 20 -206 20 -281 0z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2428 7993 l-28 -4 0 -836 c0 -460 2 -834 4 -832 2 2 18 56 36 119 39 138 112 294 175 372 78 99 189 158 296 158 188 0 343 -107 403 -278 50 -141 49 -120 56 -1212 7 -1127 5 -1098 70 -1292 131 -393 456 -667 870 -734 251 -41 684 3 956 97 196 67 306 132 433 253 174 168 280 384 311 634 7 57 10 325 8 772 -3 750 0 807 58 1007 89 308 299 508 654 621 162 52 410 100 655 129 49 6 -66 11 -390 16 -630 10 -845 -5 -1047 -73 -349 -117 -592 -368 -693 -715 -56 -195 -68 -469 -41 -1005 27 -558 -14 -790 -165 -941 -71 -71 -127 -104 -209 -123 -81 -20 -136 -20 -225 -1 -105 23 -171 59 -252 141 -116 117 -167 245 -184 464 -5 63 -9 567 -9 1120 0 670 -4 1035 -11 1095 -50 406 -254 679 -648 867 -183 88 -419 152 -656 178 -87 9 -371 11 -427 3z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7725 6949 c-411 -32 -709 -128 -959 -308 -192 -139 -321 -332 -378 -567 -21 -88 -22 -104 -28 -1334 -6 -1110 -9 -1254 -24 -1328 -22 -114 -49 -191 -102 -297 -119 -241 -311 -384 -599 -447 -90 -19 -406 -17 -522 5 -212 39 -442 136 -593 251 -78 59 -237 213 -303 295 -15 18 -29 32 -31 30 -13 -17 -248 -556 -257 -591 -15 -56 -7 -96 35 -183 117 -241 428 -437 871 -549 495 -125 995 -83 1423 119 435 206 723 542 831 970 56 222 68 535 70 1875 2 873 8 1048 41 1212 93 455 387 737 880 842 l65 14 -155 0 c-85 -1 -204 -5 -265 -9z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUjLogo);
export default __webpack_public_path__ + "static/media/UJ-logo.647e4c21ba9207fb8b36e573fb5d2a9f.svg";
export { ForwardRef as ReactComponent };